import { makeStyles } from "@material-ui/core/styles";

export const useTemplateStyles = makeStyles(
  theme => ({
    GeneralInformationRoot: {
      display: "grid",
      gridColumnGap: theme.spacing(2),
      gridTemplateColumns: "1fr"
    },
    assignStoreSearchFilter: {
      margin: "20px 0px 15px"
    },
    binText: {
      fontSize: 15,
      fontWeight: 600,
      marginLeft: 10
    },
    btnTopCreateNewTemplate: {
      borderRadius: "8px"
    },
    btnTopViewAllMalls: {
      borderRadius: "8px"
    },
    buttonAction: {
      background: "#EFF5F8",
      borderRadius: "100%",
      height: 55,
      margin: theme.spacing(0, 2),
      padding: 0,
      width: 55
    },
    buttonActionCenter: {
      alignItems: "center",
      display: "flex",
      justifyContent: "center",
      marginTop: 20
    },
    buttonActionRight: {
      alignItems: "right",
      display: "flex",
      justifyContent: "right",
      marginTop: 20
    },
    buttonBinDecrement: {
      backgroundColor: "#0030FF",
      color: "#FFFFFF",
      fontSize: 20,
      height: "30px",
      width: "30px"
    },
    buttonColor: {
      backgroundColor: "#0030FF",
      color: "#FFF",
      ...{
        "&:hover": {
          backgroundColor: "#0030FF"
        }
      }
    },
    buttonColorDisabled: {
      backgroundColor: "#E1E1E1 !important",
      color: "#FFF !important",
      ...{
        "&:hover": {
          backgroundColor: "#E1E1E1 !important"
        }
      }
    },
    buttonColorGray: {
      "& span": {
        color: "#858C94"
      },
      backgroundColor: "#FFFFFF",
      borderColor: "#858C94",
      color: "#858C94",
      ...{
        "&:hover": {
          backgroundColor: "#FFFFFF"
        }
      }
    },
    buttonColorYellow: {
      "& span": {
        color: "#002972"
      },
      backgroundColor: "#FFDF8D",
      color: "#002972",
      ...{
        "&:hover": {
          backgroundColor: "#FFDF8D"
        }
      }
    },
    buttonDecrement: {
      fontSize: 20,
      height: "10px",
      width: "10px"
    },

    buttonIncrement: {
      fontSize: 20,
      height: "10px",
      width: "10px"
    },
    cardCheckbox: {
      justifyContent: "end"
    },
    cardTitle: {
      "& span": {
        fontWeight: "500"
      }
    },
    cardTitleContainer: {
      marginBottom: "10px",
      marginTop: "-50px"
    },
    centerContent: {
      padding: "20px",
      textAlign: "center"
    },
    circle: {
      backgroundColor: "#ADB4BB",
      borderRadius: "50%",
      height: 30,
      width: 30
    },
    circleContainer: {
      display: "flex",
      justifyContent: "end"
    },
    closeButton: {
      color: theme.palette.grey[500],
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1)
    },
    container: {
      display: "grid",
      gridGap: theme.spacing(3),
      gridTemplateColumns: "repeat(12, 1fr)"
    },
    dataTitle: {
      display: "none !important"
    },
    displayFlex: {
      display: "flex"
    },
    displayFlexCenterSpaceBetween: {
      alignItems: "center",
      display: "flex",
      justifyContent: "space-between"
    },
    displayFlexDispatchIcon: {
      alignItems: "center",
      display: "flex"
    },
    displayFlexMarginLeft: {
      marginLeft: "auto"
    },
    displayFlexMarginLeft20: {
      marginLeft: "20px"
    },
    displayFlexMarginRight10: {
      marginRight: "10px"
    },
    displayFlexMarginRight20: {
      marginRight: "20px"
    },
    displayFlexMarginRight30: {
      marginRight: "30px"
    },
    displayFlexPaddingTop50: {
      paddingTop: "50px"
    },
    div100: {
      width: "100%"
    },
    divFlexCentered: {
      display: "flex",
      justifyContent: "center",
      marginBottom: 20
    },
    divFlexCentered100: {
      alignItems: "center",
      display: "flex",
      height: "100%",
      justifyContent: "center"
    },
    divFlexEnd100: {
      display: "flex",
      justifyContent: "end",
      width: "100%"
    },
    divMaxWidth90: {
      maxWidth: "90%"
    },
    dropOffCard: {
      borderRadius: "20px"
    },
    dropOffCardAccordion: {
      borderRadius: "6px"
    },
    dropOffCardAccordionBody: {
      padding: "20px"
    },
    dropOffCardAccordionMediumTitle: {
      fontSize: "15px",
      fontWeight: 600
    },
    dropOffCardAccordionSmallTitle: {
      fontSize: "12px",
      fontWeight: 700,
      letterSpacing: "0.5em"
    },
    dropOffCardAccordionTitle: {
      fontWeight: 600
    },
    dropOffChipDefault: {
      backgroundColor: "#ACCAFF",
      borderRadius: "10px",
      color: "#3B3B3B",
      fontSize: "10px",
      height: "20px",
      marginLeft: "10px",
      width: "50px"
    },
    dropOffChipRegistered: {
      backgroundColor: "#ACCAFF",
      borderRadius: "10px",
      color: "#3B3B3B",
      fontSize: "10px",
      height: "20px",
      marginLeft: "10px",
      width: "60px"
    },
    dropOffContainer: {
      minHeight: 600,
      minWidth: "100%",
      paddingBottom: "30px"
    },
    dropOffHomeLocationCard: {
      borderRadius: "12px",
      cursor: "pointer"
    },
    dropOffHomeLocationCardBody: {
      minHeight: 275
    },
    dropOffHomeLocationCardBodyContent: {
      padding: "20px"
    },
    dropOffHomeLocationCardBodyTaskAreas: {
      height: "125px",
      overflow: "auto"
    },
    dropOffHomeLocationCardDefault: {
      borderColor: "#0030ff",
      borderWidth: "2px"
    },
    dropOffTabs: {
      borderBottom: "1px solid #DDDDDD",
      tab: {
        fontWeight: "bold"
      }
    },
    dropOffTaskAreaChip: {
      borderRadius: "50px",
      display: "flex",
      fontSize: "15px",
      height: "50px",
      justifyContent: "space-between",
      padding: "10px"
    },
    gridContainerBin: {
      alignItems: "center",
      height: "40px",
      marginLeft: "25px",
      position: "relative",
      top: "-7px",
      width: "95%"
    },
    gridContainerRack: {
      alignItems: "center",
      height: "35px",
      marginLeft: "20px",
      width: "95%"
    },
    gridIconButton: {
      display: "flex",
      justifyContent: "right"
    },
    headerLeft: {
      alignItems: "center",
      display: "flex"
    },
    headerSection: {
      display: "flex",
      justifyContent: "space-between"
    },
    headerTitle: {
      alignSelf: "center",
      flex: "1",
      fontSize: "24px",
      margin: "10px 15px 25px 0px",
      padding: "0"
    },
    headerTitleMall: {},
    iconButtonDelete: {
      color: "#EC5D77"
    },
    iconLabel: {
      borderRight: "solid #C2BFBF 1px",
      fontSize: "14px",
      fontWeight: "bold",
      margin: "0 5px",
      paddingRight: "8px"
    },
    iconLabelEnd: {
      fontSize: "14px",
      fontWeight: "bold",
      margin: "0 5px",
      paddingRight: "8px"
    },
    itemCardDetails: {
      "& h3": {
        fontWeight: "bold",
        margin: "0",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
      },
      width: "calc(100% - 175px)"
    },
    itemCardStatus: {
      alignItems: "center",
      display: "flex",
      justifyContent: "flex-end"
    },
    itemIconCount: {
      fontSize: "0.8rem",
      fontWeight: "bold",
      marginLeft: "5px"
    },
    itemIconLabel: {
      fontSize: "0.8rem",
      marginLeft: "5px"
    },
    itemIconStatus: {
      alignItems: "center",
      display: "flex",
      height: "30px",
      minWidth: "150px",
      padding: "5px 5px 5px 0px"
    },
    itemIconSvg: {
      color: "#0030ff",
      fontSize: "1rem"
    },
    label: {
      marginBottom: theme.spacing(1)
    },
    leftContent: {
      padding: "10px 0px",
      textAlign: "left"
    },
    mallTitle: {
      display: "grid",
      fontWeight: 600,
      gridColumnGap: theme.spacing(4),
      gridTemplateColumns: "1fr",
      marginBottom: "20px",
      marginTop: "-25px"
    },
    menu: {
      "& ul": {
        padding: "10px 0 !important"
      }
    },
    menuItem: {
      borderRadius: "0",
      fontWeight: "bold",
      justifyContent: "center !important",
      padding: "6px 16px !important",
      width: "140px",
      ...{
        "&:hover": {
          backgroundColor: "#0630ff !important",
          color: "#FFF",
          fontWeight: "bold"
        }
      }
    },
    modalContentText: {
      margin: "0"
    },
    padding0: {
      padding: 0
    },
    paper: {
      color: theme.palette.text.secondary,
      marginBottom: theme.spacing(1),
      padding: theme.spacing(1),
      textAlign: "center",
      whiteSpace: "nowrap"
    },
    prop: {
      marginBottom: theme.spacing(2)
    },
    root: {
      overflow: "visible"
    },
    sectionTitle: {
      fontWeight: 600,
      marginBottom: theme.spacing(),
      marginTop: theme.spacing(2)
    },
    stepLabelActive: {
      fontSize: "12px !important",
      fontWeight: 600
    },
    stepLabelCompleted: {
      fontSize: "12px !important",
      fontWeight: "bold"
    },
    switchAlreadyActive: {
      display: "flex",
      marginLeft: "55px"
    },
    switchCircleActive: {
      color: "#FFDB00 !important",
      height: "40px",
      margin: "10px 0px 0px 8px",
      width: "40px"
    },
    taskAreaCard: {
      height: 490,
      overflow: "visible"
    },
    taskAreaCardAddRemove: {
      borderColor: "#0030FF",
      borderWidth: "2px",
      color: "#0030FF"
    },
    taskAreaCardAddRemoveText: {
      fontWeight: 600
    },
    taskAreaCardBoxDispatchIcon: {
      alignItems: "center",
      display: "flex",
      marginTop: "10px"
    },
    taskAreaCardButton: {
      alignItems: "center",
      display: "flex",
      justifyContent: "end"
    },
    taskAreaCardContent: {
      maxHeight: 425,
      overflow: "auto",
      padding: 0
    },
    taskAreaCardDiv: {
      display: "grid",
      gridColumnGap: theme.spacing(4),
      gridTemplateColumns: "1fr",
      marginTop: "10px",
      minHeight: "600px"
    },
    taskAreaCardStores: {
      alignItems: "center",
      display: "flex"
    },
    taskAreaCardStoresText: {
      color: "#0030ff",
      marginLeft: 5
    },
    taskAreaName: {
      paddingLeft: "0px"
    },
    templateCard: {
      marginBottom: 50,
      marginTop: 20
    },
    templateDialogTitle: {
      marginLeft: 2
    },
    templateItemAction: {
      alignItems: "center",
      display: "flex",
      justifyContent: "center",
      width: "15%"
    },
    templateItemCard: {
      backgroundColor: "#EFF5F8",
      borderRadius: "8px",
      display: "flex",
      marginBottom: "10px",
      padding: "16px 23px",
      width: "85%"
    },
    templateItemCardActive: {
      "& h3, svg, span": {
        color: "#FFF"
      },
      backgroundColor: "#0030ff"
    },
    templateItemRow: {
      alignItems: "center",
      display: "flex",
      padding: "0 10px",
      width: "100%"
    },
    templateItemStatusListIcons: {
      "& > div:not(:first-child)": {
        paddingLeft: "5px"
      },
      "& > div:not(:last-child)": {
        borderRight: "1px solid rgba(0,0,0,0.1)"
      },
      display: "flex",
      justifyContent: "flex-start"
    },
    templateItems: {
      width: "100%"
    },
    templateTitle: {
      alignItems: "center",
      display: "flex",
      justifyContent: "space-between",
      padding: "0 16px",
      width: "100%"
    },
    templateTitleActions: {
      padding: "0 5% 0 0"
    },
    templateTitleAvailable: {
      color: "rgb(116, 124, 140)"
    },
    templateTitleFilter: {
      display: "flex",
      marginLeft: "auto",
      marginRight: "50px"
    },
    templateTitleLabelContainer: {
      justifyContent: "normal",
      padding: "0 50px"
    },
    templateTitleLabels: {
      alignItems: "center",
      display: "flex",
      margin: "0 15px"
    },
    templateTitleNoAvailable: {
      textAlign: "center",
      width: "100%"
    },
    textBackButton: {
      color: "#0030FF"
    },
    textButton: {
      color: "#FFF"
    },
    textFieldGrid: {
      display: "grid",
      gridColumnGap: theme.spacing(2),
      gridTemplateColumns: "1fr 1fr"
    },
    textFont30: {
      fontSize: 30
    },
    textGray: {
      color: "#F1F2F3"
    },
    textMarginLeft: {
      marginLeft: "10px"
    },
    textPrimary: {
      color: "#0030ff"
    },
    textWhite: {
      color: "#FFF"
    },
    title: {
      fontSize: 10
    },
    value: {
      fontSize: 20
    }
  }),
  { name: "DropOffTemplateStyles" }
);

export const STYLE_HL_REGISTERED = {
  color: "#00C6A2"
};
export const STYLE_HL_UNREGISTERED = {
  color: "#EC5D77"
};
export const STYLE_HL_INCOMPLETE_REGISTRATION = {
  color: "#E7AF3A"
};
export const STYLE_HL_REGISTERED_DARKER = {
  color: "#246C63"
};
